import { combineReducers } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import addressSlice from './address';
import authSlice from './auth';
import autoPrintSlice from './autoPrint';
import bankSlice from './bankConfigurations';
import batchBikersSlice from './batchBikers';
import callerIdSlice from './callerId';
import cartSlice from './cart';
import categorySlice from './category';
import defaultDescriptionsSlice from './defaultDescriptions';
import vendorDeliveryZoneSlice from './deliveryZone';
import discountCodeSlice from './discountCode';
import { draftBasketSlice } from './draftBasket';
import foodShiftsSlice from './foodShifts';
import reportHourlySlice from './hourlyReports';
import menuItemSlice from './menuItem';
import networkSlice from './networkStatus';
import offlineAddressSlice from './offlineAddress/index';
import offlineOrderingSlice from './offlineOrdering';
import { orderingSlice } from './ordering';
import { orderingPrinterSlice } from './orderingPrinter';
import orderingStepperSlice from './orderingStepper';
import orderSlice from './orders';
import otpSlice from './otp';
import { posTerminalSlice } from './posTerminal';
import printerStation from './printerStation';
import printersSlice from './printers';
import reportsSlice from './reports';
import toppingsSlice from './toppings';
import updateOrderSlice from './updateOrder';
import userConfSlice from './userConf';
import userTransactionsSlice from './userTransactions';
import usersSlice from './users';
import vendorSlice from './vendor';
import vendorInformationSlice from './vendorInformation';
import vendorSettlementsSlice from './vendorSettlements';
import vendorStaffSlice from './vendorStaff';

const rootReducer = combineReducers({
  cart: cartSlice.reducer,
  auth: authSlice.reducer,
  otp: otpSlice.reducer,
  address: addressSlice.reducer,
  order: orderSlice.reducer,
  userConf: userConfSlice.reducer,
  vendor: vendorSlice.reducer,
  discountCode: discountCodeSlice.reducer,
  users: usersSlice.reducer,
  category: categorySlice.reducer,
  menuItem: menuItemSlice.reducer,
  reports: reportsSlice.reducer,
  reportHourly: reportHourlySlice.reducer,
  userTransaction: userTransactionsSlice.reducer,
  vendorSettlements: vendorSettlementsSlice.reducer,
  vendorInformation: vendorInformationSlice.reducer,
  vendorDeliveryZone: vendorDeliveryZoneSlice.reducer,
  vendorStaff: vendorStaffSlice.reducer,
  foodShifts: foodShiftsSlice.reducer,
  toppings: toppingsSlice.reducer,
  printers: printersSlice.reducer,
  printerStation: printerStation.reducer,
  defaultDescriptions: defaultDescriptionsSlice.reducer,
  offlineOrdering: offlineOrderingSlice.reducer,
  offlineAddress: offlineAddressSlice.reducer,
  bank: bankSlice.reducer,
  updateOrder: updateOrderSlice.reducer,
  networkStatus: networkSlice.reducer,
  orderingStepper: orderingStepperSlice.reducer,
  batchBikers: batchBikersSlice.reducer,
  autoPrint: autoPrintSlice.reducer,
  callerId: callerIdSlice.reducer,
  ordering: orderingSlice.reducer,
  draftBasket: draftBasketSlice.reducer,
  posTerminal: posTerminalSlice.reducer,
  orderingPrinter: orderingPrinterSlice.reducer,
});

export default rootReducer;
